import { postRawRequest } from '../../httpClient';
import type { IBackfillTranslationsRequest } from './backfill-translations-request';

const ONE_HOUR_MS = 3_600_000;

export async function backfillTranslationsStreamApi(
  body: IBackfillTranslationsRequest = {},
): Promise<Response> {
  return postRawRequest({
    path: '/sys/challenges/backfill-translations/stream',
    body,
    options: { timeout: ONE_HOUR_MS },
  });
}
